/* eslint-disable max-params */
import React, { useContext } from "react";
import IconFont from "@/components/icon";
import { mapUserDataToUid } from "@/utils/chat/message";
import { UserCardData, UserCardType } from "@/types/UserCard";
import ImService from "@/server/ImService";
import { message, Modal } from "antd";
import Bus from "@/utils/bus";
import { useHistory, useLocation } from "react-router-dom";
import i18n from "@/i18n";
import { acceptFriend, handleCreateGroupXCMeeting, isOuterApp } from "../AddressBook/common";
import RosterApplyStatus from "@jd/jdee.im.sdk/lib/es/enum/RosterApplyStatus";
import { isSelf, UserModel } from "@/models/user";
import { ConferenceApplyRequest, ConferenceType } from "../Voip/types";
import { FocusSDK } from "@/utils";
import dayjs from "dayjs";
import { AVSDK } from "@/baseComponents/Meeting/common";
import { Employee, Session, UID } from "@/types/chat";
import { analysisLog } from "@/utils/logAnalytics";
import { getPreviewImageModal } from "../chat/utils/commonMessageModal";
import { getExtName, isChatPage } from "@/utils/chat/index";
import { ListItemData } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { syncConfirmNew } from "@/utils/syncConfirm";
import { handleCreateSingleMeeting as handleCreateSingleZoomMeeting } from "../Meeting/utils";
import { handleCreateSingleMeeting, getApplicationId } from "@/baseComponents/Meeting/utils";
import { getAppApplyStatus, AppTrialStatus } from "../ThirdApp/utils";

export const Line = () => {
  const style: React.CSSProperties = {
    background: "#f3f3f3",
    height: "1px",
    width: "290px",
    // float: 'right',
    margin: "0 auto"
  };
  return <div style={style} />;
};

export const SplitLine = () => {
  return <div className="usercard-item-splitline" />;
};

export const getSexNode = (sex: any) => {
  if (!sex || sex === "2") {
    return "";
  } else if (sex === "0") {
    return <IconFont style={{ color: "#FF6792" }} type="iconapp_sex_female" />;
  } else {
    return <IconFont style={{ color: "#2E8EFF" }} type="iconapp_sex_male" />;
  }
};

// export const NameSig = (props: {
//     isSelf: boolean;
//     name?: string;
//     sig?: string;
//     onModifySig?: ModifySettingFn;
//     t: any;
//     sex: any;
// }) => {
//     const { name, sig, t, isSelf, onModifySig, sex } = props;
//     const [value, setValue] = useState('');
//
//     useEffect(() => {
//         setValue(sig);
//     }, [sig]);
//
//     const saveSig = async (value: string) => {
//         await onModifySig({
//             settingCode: 'signature',
//             settingContent: value,
//         });
//     };
//
//     const doSaveDebounce = useRef(debounce(saveSig, 500)).current;
//
//     return (
//         <div
//             className="me-user-card-namesig"
//             style={{
//                 padding: '18px 20px',
//             }}
//         >
//             <h4
//                 className="usercard-namesig-title"
//                 style={{
//                     fontSize: 18,
//                     // color: styles.color.black,
//                     lineHeight: '24px',
//                     margin: 0,
//                 }}
//             >
//                 {name || t('userCard.titleDefaultStr')}
//                 {!sex || sex === '2' ? (
//                     ''
//                 ) : (
//                     <img
//                         src={sex === '0' ? Woman : Man}
//                         style={{ width: '14px', height: '14px', margin: ' 0 0 6px 8px' }}
//                     />
//                 )}
//             </h4>
//
//             {isSelf ? (
//                 <Input
//                     maxLength={50}
//                     placeholder={t('userCard.workStatusDefaultStr')}
//                     value={value}
//                     onChange={(e) => {
//                         setValue(e.target.value);
//                         doSaveDebounce(e.target.value);
//                     }}
//                     style={{
//                         border: 'none',
//                         resize: 'none',
//                         color: '#242931',
//                         maxHeight: '73px',
//                         marginTop: '6px',
//                     }}
//                     allowClear
//                 />
//             ) : (
//                 <p
//                     className="usercard-namesig-desc"
//                     style={{
//                         margin: 0,
//                         // color: styles.color.gray,
//                         fontSize: 13,
//                         lineHeight: '18px',
//                     }}
//                 >
//                     {sig || ''}
//                 </p>
//             )}
//         </div>
//     );
// };

export function mapUserDataToUserCard(item: ListItemData): UserCardData {
  return {
    ...item,
    type: UserCardType.User,
    userId: item.userId || item.pin,
    teamId: item.teamId || "",
    appId: item.app || item.appId,
    fields: [
      {
        name: "姓名",
        val: item.name || item.nickName,
        key: "name",
        hide: 1,
        index: 0
      },
      {
        name: "头像",
        val: item.avatar,
        key: "avatar",
        hide: 1,
        index: 1
      }
    ]
  };
}

// 个人名片页----拉起会话
export function launchSession(userCardData: UserCardData, location: any, history: any) {
  // console.log("startSessionFromUserCardCb ==>", userCardData);
  // // eslint-disable-next-line react-hooks/rules-of-hooks
  // const history = useHistory();
  // // eslint-disable-next-line react-hooks/rules-of-hooks
  // const location = useLocation();
  const { app, pin, teamId } = mapUserDataToUid(userCardData);
  Bus.emit("app:toggle-user-card-modal:hide");
  // tj: 判断是否是当前会话, 解决当前会话跳转不获取消息
  // TODO: 单聊密聊会话跳转 参数添加isSecret 按道理说个人卡片跳转的是普通单聊
  const path = `/messages/s/${pin}?app=${app}&tid=${teamId}`;
  const currPath = location.pathname;
  const currQuery = location.search.replace("&top=true", "");
  if (path !== `${currPath}${currQuery}`) {
    setTimeout(() => {
      if (!pin) return;
      if (isChatPage()) {
        FocusSDK.launchNewSession(`${path}&top=true`);
      } else {
        history.push(`${path}&top=true`);
      }
    }, 1);
  }
  return { close: true, data: true };
}

// 个人名片页----申请好友
export async function applyFriend(data: UserCardData, accessPhone = "", currentEmployee: any) {
  const imService = ImService.getInstance();
  const user: UID = { app: data.appId, teamId: data.teamId, pin: data.userId };
  // // 获取好友关系
  // const [ship] = await imService.getContactShip([user]);
  // const relationship = ship.relationship;
  // if (relationship.friendship === 1) {
  //     toast.warn(t('userCard.friend-ship'));
  //     // return false;
  //     return { close: false, data: false };
  // }

  const [result, err]: any = await imService.applyFriend({
    user: user,
    remark: data.remark,
    info: data.validationMsg,
    accessPhone,
    acrossApp: isOuterApp(user, currentEmployee)
  });

  if (result) {
    message.success(i18n.t("common:userCard.tips.sendSuccess"));
  } else {
    message.error(err);
  }

  return { close: false, data: result };
}

// 个人名片页----接受 - 加为好友 外部联系人、跨租户需要二次确认
export async function doAcceptFriend(data: UserCardData, accessPhone = "", currentEmployee: any) {
  let ExternalOrOtherTeam = -1;
  if (data.labelInfoList) {
    ExternalOrOtherTeam = data.labelInfoList.findIndex(
      (item) =>
        (item.label === "isExternal" && item.isShow === "1") ||
        (item.label === "otherTeam" && item.isShow === "1")
    );
  }
  if (ExternalOrOtherTeam !== -1) {
    Modal.confirm({
      title: "提示",
      content: "通过验证后对方可查看您的部门、职务、信息",
      okText: "确定",
      cancelText: "取消",
      async onOk() {
        return await AcceptFriend(data, accessPhone, currentEmployee);
      }
    });
  } else {
    return await AcceptFriend(data, accessPhone, currentEmployee);
  }
  return { close: true, data: false };
}

// 个人名片页----接受 - 加为好友
export async function AcceptFriend(data: UserCardData, accessPhone = "", currentEmployee: any) {
  const user: UID = { app: data.appId, teamId: data.teamId, pin: data.userId };
  const [result, err] = await acceptFriend({
    user: user,
    remark: data.remark,
    status: RosterApplyStatus.Approved,
    accessPhone,
    acrossApp: isOuterApp(user, currentEmployee)
  });
  // const result = await acceptFriend({ user, status: RosterApplyStatus.Approved });q`
  if (result) {
    message.success(i18n.t("common:userCard.tips.success"));
    // if (!isFocusEnv()) {
    Bus.emit("app:toggle-user-card-modal:hide");
    Bus.emit("app:toggle-user-card-modal:update-new-contacts", user);
    // }
  } else {
    message.error(err);
    // message.error(t('userCard.tips.failed'));
  }
  // return result;
  return { close: true, data: result };
}

// 个人名片页----申请加群
export async function applyAddGroup(data: any, currentEmployee: Employee) {
  // return true;
  const user: UID = {
    app: currentEmployee.app,
    teamId: currentEmployee.teamId,
    pin: currentEmployee.userId,
    name: currentEmployee.name || ""
  };
  const groupId = data.group?.id;
  if (!groupId) {
    return false;
  }
  const imService = ImService.getInstance();
  const reason = data.group?.validationMsg || "";
  const result = await imService.applyAddGroup(groupId, [user], "application", reason);

  // if (isFocusEnv()) {
  //     return { close: false, data: result };
  // }
  //
  // // return result;
  return { close: false, data: result };
}

export async function joinGroup(data: any, currentEmployee: Employee, history: any) {
  const { id } = data.group;
  const user: UID = {
    app: currentEmployee.app,
    teamId: currentEmployee.teamId,
    pin: currentEmployee.userId,
    name: currentEmployee.name || ""
  };
  const imService = ImService.getInstance();
  const result = await imService.joinGroup(id, user);
  if (result === 0) {
    Bus.emit("app:toggle-user-card-modal:hide");
    setTimeout(() => {
      history.push(`/messages/g/${id}?top=true`);
    }, 1);
  } else if (result < 0) {
    message.error(i18n.t("common:search.operate_failed"));
  } else if (result.toString() === "1103006") {
    // 人数太多
    message.warn("search.max_group_rosters");
  } else if (result.toString() === "1103036") {
    // 是入审批流程
    // openGroupCardModal(item, [UserCardAction.SendApplyGroup]);
    // 发送审批
    return true;
  } else {
    message.error(i18n.t("common:search.operate_failed"));
  }
}

export async function startVoip(data: UserCardData, currentEmployee: Employee) {
  const res = await syncConfirmNew("是否发起语音通话？", "语音通话");
  if (!res) {
    return;
  }
  message.info(i18n.t("meeting:meeting initialization"));
  // 处理一下连点场景
  // if (voipClick) {
  //     return;
  // }
  // SetVoipClick(true);
  // setTimeout(() => {
  //     SetVoipClick(false);
  // }, 5000);
  const { app, pin, teamId, name } = mapUserDataToUid(data);
  // const { userId, teamUserInfo } = userData;
  const imService = ImService.getInstance();
  const sessionId = imService.generateSingleSessionId(
    // @ts-ignore
    {
      app: currentEmployee.app,
      userId: currentEmployee.userId,
      teamId: currentEmployee.teamId
    },
    { app, pin, teamId }
  );
  const opts: Partial<ConferenceApplyRequest> = {
    topic: i18n
      .t("chat:voip.meetingTopicDesc")
      .replace("%from", currentEmployee.name)
      .replace("%to", name || ""),
    conference_type: ConferenceType.kConferenceSingle,
    sid: sessionId, //
    start: dayjs().valueOf()
    // duration: '1.0',
  };
  FocusSDK.sendIpcMessage("voip:createSingleCall", {
    request: opts,
    invite: {
      member_app_: app,
      member_id_: pin,
      team_id_: teamId
    }
  });
}

export async function startJrtc(data: UserCardData, currentEmployee: Employee, type?: string) {
  if (type !== "voice") {
    const appApplyStatus = await getAppApplyStatus(getApplicationId(AVSDK.JBRTC), true);
    if (appApplyStatus !== AppTrialStatus.NORMAL) {
      message.warn("请您从工作台进入智能会议应用申请试用权限");
      return;
    }
  }
  const typeDesc = type === "voice" ? "语音通话" : "视频通话";
  const res = await syncConfirmNew(`是否发起${typeDesc}？`, typeDesc);
  if (!res) {
    return;
  }
  const { app, pin, teamId, name, avatar } = mapUserDataToUid(data);
  handleCreateSingleMeeting({
    from: {
      pin: currentEmployee.userId,
      teamId: currentEmployee.teamId,
      name: currentEmployee.name,
      app: currentEmployee.app,
      avatar: currentEmployee.avatar
    },
    avsdk: AVSDK.JBRTC,
    type,
    to: {
      pin,
      teamId,
      name: name || "",
      app,
      avatar: avatar || ""
    }
  }).catch((e) => {
    console.error(e);
    message.error(e?.message || e || "创建会议失败");
  });
  setTimeout(() => {
    Bus.emit("app:toggle-user-card-modal:hide", {});
  }, 500);
}
// export async function handleCreateZoomMeeting(
//   data: UserCardData,
//   currentEmployee: Employee,
//   newPublicResult?: boolean
// ) {
//   const appApplyStatus = await getAppApplyStatus(getApplicationId(AVSDK.ZOOM), true);
//   if (appApplyStatus !== AppTrialStatus.NORMAL) {
//     message.warn("请您从工作台进入视频会议应用申请试用权限");
//     return;
//   }
//   if (FocusSDK.isPrivateNet()) {
//     if (newPublicResult === false) {
//       message.warn(i18n.t("common:joinMeeting.private net"));
//       return;
//     }
//   }

//   const res = await syncConfirmNew("是否发起视频通话？", "视频通话");
//   if (!res) {
//     return;
//   }
//   const { app, pin, teamId, name, avatar } = mapUserDataToUid(data);

//   handleCreateSingleZoomMeeting({
//     from: {
//       pin: currentEmployee.userId,
//       name: currentEmployee.name,
//       teamId: currentEmployee.teamId,
//       app: currentEmployee.app,
//       avatar: currentEmployee.avatar
//     },
//     to: {
//       pin,
//       teamId,
//       name: name || "",
//       app,
//       avatar: avatar || ""
//     }
//   }).catch((e) => {
//     message.error(e?.message || e || "创建会议失败");
//   });
// }

// 创建视频会议
export async function handleCreateGroupMeeting(
  data: UserCardData,
  currentEmployee: Employee,
  newPublicResult?: boolean
) {
  const appApplyStatus = await getAppApplyStatus(getApplicationId(AVSDK.ZOOM), true);
  if (appApplyStatus !== AppTrialStatus.NORMAL) {
    message.warn("请您从工作台进入视频会议应用申请试用权限");
    return;
  }
  if (FocusSDK.isPrivateNet()) {
    if (newPublicResult === false) {
      message.warn(i18n.t("common:joinMeeting.private net"));
      return;
    }
  }
  const res = await syncConfirmNew("是否发起视频通话？", "视频通话");
  if (!res) {
    return;
  }
  const fields: { [propName: string]: any } = {};
  (data.fields || []).forEach((fieldItem: any) => {
    fields[fieldItem.key] = fieldItem.val;
  });

  handleCreateSingleZoomMeeting({
    from: {
      pin: currentEmployee.userId,
      teamId: currentEmployee.teamId,
      app: currentEmployee.app,
      avatar: currentEmployee.avatar,
      name: currentEmployee.name
    },
    to: {
      name: fields.name,
      teamId: data.teamId,
      pin: data.userId,
      app: data.appId,
      avatar: fields.avatar
    }
  }).catch((e) => {
    message.error(e?.message || e || "创建会议失败");
  });
  setTimeout(() => {
    Bus.emit("app:toggle-user-card-modal:hide", {});
  }, 500);
}

export function handleCreateXCMeeting(data: any) {
  handleCreateGroupXCMeeting([data], data?.memberType || 1);
}

export async function replyApplyMessage({
  data,
  currentEmployee,
  replyMsg,
  applyId,
  flag,
  reply
}: {
  data: UserCardData;
  currentEmployee: any;
  replyMsg: string;
  applyId: number;
  flag: number;
  reply: number;
}) {
  const { userId, appId, teamId } = data;
  try {
    const imService = ImService.getInstance();
    await imService.sendApplyRosterMsg({
      user: {
        pin: userId,
        app: appId,
        teamId: teamId
      },
      info: replyMsg,
      applyId,
      flag,
      reply
    });
    return { close: true, data: true };
  } catch (e) {
    message.error(e);
    return { close: true, data: false };
    // message.error(i18n.t("common:userCard.removeFriendFailed"));
  }
}

export async function removeFriend(data: UserCardData, currentEmployee: any) {
  const { userId, appId, teamId } = data;

  Modal.confirm({
    zIndex: 2000,
    title: i18n.t("common:userCard.tip"),
    content: i18n.t("common:userCard.removeTips"),
    okText: i18n.t("common:button.ok"),
    cancelText: i18n.t("common:button.cancel"),
    async onOk() {
      try {
        const imService = ImService.getInstance();
        await imService.setRemoveFriend({
          pin: userId,
          app: appId,
          teamId: teamId,
          acrossApp: isOuterApp({ appId }, currentEmployee)
        });
        Bus.emit("friend:removeFriend", { userId: userId, app: appId, teamId: teamId });
        message.success(i18n.t("common:userCard.removeFriendOk"));
      } catch (e) {
        message.error(e);
        // message.error(i18n.t("common:userCard.removeFriendFailed"));
      }
      Bus.emit("app:toggle-user-card-modal:hide", {});
    }
  });
}

export function getIsSelf(userData: UserModel, userCard: any) {
  const data = {
    ddAppId: userCard.appId,
    userId: userCard.userId,
    selectedTeamId: userCard.teamId
  };
  return isSelf(userData, data);
}

export function onClickAvatar(data: any) {
  let url = data?.fields.filter((item: any) => item.key === "avatar")[0]?.val;
  let fileName = data?.fields.filter((item: any) => item.key === "name")[0]?.val;
  analysisLog("xtbg_add_home_1637657110163", "43");
  const [partI] = url?.split("?") || "";
  const extName = getExtName(partI);
  fileName = `${fileName}.${extName || "jpg"}`;
  getPreviewImageModal({
    message: { muuid: 1, url: url, fileName: fileName },
    isMergeForward: true,
    modalMessages: [{ url: url, fileName: fileName, muuid: 1, kind: "image" }]
  });
}
